import {observer} from "mobx-react";
import {ConfirmModalDialog, Linq, Page, ScrollTable} from "../../ui";
import {DialogStore, fmsDocumentPrinterStore, FmsModalDialogPrintStore, fmsPicklistDetailStore} from "../../../store";
import {convertDocumentType} from "../../../api";
import {dateFormat} from "../../../utils";
import "./FmsPicklistDetailPage.scss"
import {useBlocker} from "react-router";
import {useEffect, useState} from "react";
import {FmsModalDialogPrintDocument} from "./FmsModalDialogPrintDocument";

const DetailIntro = observer(function DetailIntro() {
    return <div
        style={{
            padding: '1em',
            display: 'flex'
        }}
    >
        <div
            style={{
                flex: '1'
            }}
        >
            <div style={{marginBottom: '1em'}}>
                <label className={"label has-text-info"} style={{marginBottom: '0'}}>Pickliste</label>
                <h4 className={"title is-4 has-text-primary last-scan"}>
                    {fmsPicklistDetailStore.hasScanItem && <>
                        Last Scan aktiv
                        <span style={{position: 'relative'}}><span className={'color-box'}></span></span>
                    </>}
                </h4>
            </div>
        </div>
    </div>
})

const FmsPicklistDetailPage = observer(function FmsPicklistDetailPage() {
    const items = fmsPicklistDetailStore.data?.items || []

    const [confirmStore] = useState(new DialogStore())
    const [printDocumentDialog] = useState(new FmsModalDialogPrintStore())

    const blocker = useBlocker((({ currentLocation }) =>
            currentLocation.pathname.startsWith('/fms/picklist/')
    ))

    useEffect(() => {
        if (fmsPicklistDetailStore.hasScanItem) {
            if (blocker.state === 'blocked') {
                confirmStore.dialogOpen = true
            }
        } else {
            if (blocker.state === 'blocked') {
                blocker.proceed()
            }
        }
    }, [blocker, confirmStore])

    return <Page
        cssSuffix={`fms detail`}
        breadcrumb={[
            {
                link: '/fms',
                label: 'Versand'
            },
            {
                link: `/fms/picklist`,
                label: 'Picklisten'
            },
            {
                link: `/fms/picklist/${fmsPicklistDetailStore.id}`,
                label: 'Detailansicht'
            }
        ]}
        topper={<DetailIntro/>}
        actions={[{
            label: 'Pickliste drucken',
            action: async () => {
                printDocumentDialog.dialogOpen = true
                fmsDocumentPrinterStore.load().finally()
            },
            icon: 'print'
        }]}
    >
        <>
            <ConfirmModalDialog
                store={confirmStore}
                title={"Last Scan verlassen"}
                label={"Last Scan verlassen"}
                message={<strong className={'has-text-danger'}>Es sind noch Dokumente ohne Last Scan vorhanden.</strong>}
                execute={async () => {
                    if (blocker.state === 'blocked') {
                        blocker.proceed()
                    }
                }}
            />
            <FmsModalDialogPrintDocument
                store={printDocumentDialog}
                action={async (printerId) => await fmsPicklistDetailStore.print(printerId)}
            />
            <ScrollTable>
                <thead>
                <tr>
                    <th>FIN</th>
                    <th>Dokumentenart</th>
                    <th>Lagerort</th>
                    <th>Last-Scan</th>
                    <th>Dokumenten-Id</th>
                </tr>
                </thead>
                <tbody>
                {items.map((val) => {
                    return <tr key={val.id} className={`${val.lost ? 'is-warning' : ''}`}>
                        <td style={{display: 'flex'}}>
                            <span>{val.vin}</span>
                            <Linq
                                style={{height: '1em'}}
                                to={`/vhs?q=${val.vin}`}><span
                                className="material-symbols-outlined has-text-link">link</span></Linq>
                        </td>
                        <td>{convertDocumentType(val.documentType)}</td>
                        <td>{val.storageLocation}</td>
                        <td>{dateFormat(val.lastScan)}</td>
                        <td>{val.documentId}</td>
                    </tr>
                })}
                </tbody>
            </ScrollTable>
        </>
    </Page>
})

export {
    FmsPicklistDetailPage
}
